import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import Box from '@mui/material/Box';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "../ServicesSections.module.scss";

import InstagramEmbed from "react-instagram-embed";


export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            Overview of our Social Media Marketing Services
          </h3>
          <p>
            <a
              href="https://www.statista.com/statistics/304862/number-of-facebook-users-in-australia/"
              target="_blank"
            >
              15 million
            </a>{" "}
            Aussies are on Facebook.
            <a
              href="https://www.linkedin.com/pulse/celebrating-10-million-members-australia-most-viewed-profiles-kumar"
              target="_blank"
            >
              Over 10 million
            </a>{" "}
            are on linkedin and{" "}
            <a
              href="https://www.statista.com/forecasts/1144980/twitter-users-in-australia"
              target="_blank"
            >
              5.3 million
            </a>{" "}
            on Twitter <br />
            <br />
            The global pandemic has obviously sent social media usage through
            the roof. But just as we are using social media more, people are
            more savvy with their time. They'll turn off{" "}
            <strong>quickly</strong> if your ads is in any way annoying,
            intrusive or inappropriate
            <br />
            <br />
            Our experience as shown the importance of 1. formulating the right
            audience, 2. formulating the right message and 3. delivering it in
            an engaging way. <br />
            <br />
            <strong>Sounds easy right?</strong> Well yes and no… it really comes
            down to how much work you put in. Having the experience and knowhow
            of the tools you need and what to do in advance will give you a
            massive advantage - and thats where we come in 😀 <br />
            <br />
          </p>
          <InstagramEmbed
            url="https://instagr.am/p/Zw9o4/"
            clientAccessToken="123|456"
            maxWidth={320}
            hideCaption={false}
            containerTagName="div"
            protocol=""
            injectScript
            onLoading={() => {}}
            onSuccess={() => {}}
            onAfterRender={() => {}}
            onFailure={() => {}}
          />
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <h3 className={classes.title}>
            Actual examples of our analytical approach & expertise
          </h3>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/facebook-marketing-services/campaign-management-sm.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Campaign Management
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/facebook-marketing-services/fb-dashboard-sm.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Reports in Data Studio
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/facebook-marketing-services/video-production-sm.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Video Ads Production
                </i>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            LinkedIn, Facebook, Twitter, Insta... you need them all!!
          </h3>
          <p>
          Gone are the days of “setting and forgetting” ads on Facebook. People
          spend time on all of the various platforms, for different reasons.
          Some of the platforms are more likely to attract certain demographics
          of people. While all of that sounds obvious, managing your messaging
          across all of these platforms is far from it.
          </p>
          <p>
          Not only that, knowing the idiosyncrasies of the tools used on each
          platform is not easy. You need to be everywhere, with a crafted
          message for each platform - but how?
          </p>
          <h3 className={classes.title}>Our difference</h3>
          <h5 className={classes.title}>Campaign Management</h5>
          <Box sx={{'& li': {fontSize: "16px"}}}>
          <ol>
            <li>
              Experts in Facebook Business Suite (incoluding Instagram),
              Linkedin Campaign Manager, Twitter Ads{" "}
            </li>
            <li>
              We've run counteless campaigns across all the major platforms and
              know their pain points{" "}
            </li>
            <li>
              We check all our campaigns in a daily standup meeting to make sure
              your campaigs are runing at their best
            </li>
            <li>
              We structure campaigns the right way - so you'll find what you
              need easily
            </li>
          </ol>
          </Box>
        </GridItem>

        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/social-media-marketing-services/targeting.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Event specific targeting
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/social-media-marketing-services/linkedin-conversions.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Linkedin Conversions
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/social-media-marketing-services/audience-creation-linkedin.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Linkedin Custom Audiences
                </i>
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h5 className={classes.title}>Advanced Analytics</h5>
          <Box sx={{'& li': {fontSize: "16px"}}}>
          <ol>
            <li>We are experts in Google Tag Manager </li>
            <li>
              Our first step is to install pixels for your campaign landing
              pages
            </li>
            <li>
              We tag up your campaigns properly so the right conversion events
              are recorded and campaign optimised accordingly{" "}
            </li>
            <li>We have best in breed reporting through Data Studio</li>
            <li>
              Want to see if that qualified lead converted offline? We use
              advanced analytics through 3rd party platforms like GTM and
              salesforce to link up your offline sales.
            </li>
          </ol>
          </Box>
          <h5 className={classes.title}>Memorable Creative</h5>
          <Box sx={{'& li': {fontSize: "16px"}}}>
          <ol>
            <li>
              {" "}
              We painstakingly research your audience to come up with the best
              messaging you need
            </li>
            <li>
              {" "}
              We actively create ads and video both ourselves and with the
              assistance of our partners at FlexisourceIT and Messy Design
            </li>
            <li>
              {" "}
              We can create camapigns relevant to the size of your budget
            </li>
          </ol>
          </Box>
        </GridItem>
        <GridItem
          xs={12}
          sm={10}
          md={10}
          className={classes.section}
          style={{ paddingTop: "10px" }}
        >
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/social-media-marketing-services/quallogi.webp"
                alt="..."
                className={imgClasses}
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/social-media-marketing-services/bizcap.webp"
                alt="..."
                className={imgClasses}
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <img
                src="/img/sections/services/social-media-marketing-services/rsd.webp"
                alt="..."
                className={imgClasses}
              />
              <br />
              <br />
              <br />
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <Quote
            textClassName={classes.quoteText}
            text="“The work completed for Prezzee has not only improved the analytics and tagging functions, but also had a positive impact of user experience as well as improvements to Prezzee’s back end processes.”"
            author="Renee Gangemi, Director at The Marketing Equation / Prezzee"
          />

          <h3 className={classes.title}>Our guarantee to you:</h3>
          <Box sx={{'& li': {fontSize: "16px"}}}>
            <ul>
              <li>No Lock in Contracts </li>
              <li>We treat your campaigns as if they were my own </li>
              <li>
                Full transparency over the costs, you have admin access to the
                account
              </li>
              <li>100% Customer Satisfaction, Real Results</li>
              <li>
                All keywords are carefully selected. We don't want you to have
                unwanted traffic that you pay for
              </li>
            </ul>
          </Box>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our Approach</h3>

          <p>
            We see digital marketing as a great relationship, from the very
            first chat to a happily ever after. Here's how it works:
            <br />
          </p>
          <Box sx={{'& li': {fontSize: "16px"}}}>
            <ol>
              <li>
                <strong>Fill in the form at the bottom of this page</strong>:
                During the call, we get to know each other, to understand your
                goals and for you to understand how we can help you.{" "}
                <i>(We get to know each other on our first date!)</i>
              </li>
              <li>
                {" "}
                <strong>We get down to creating a marketing plan for you</strong>:
                The plan will be specifically tailored to your business needs and
                goals
                <i>
                  (This is where the magic happens! Sparks flies, butterflies in
                  stomach, think of the possibilities!)
                </i>
              </li>
              <li>
                {" "}
                <strong>We execute your marketing plan:</strong> This is where you
                watch your revenue grow.{" "}
                <i>
                  (Like any good date, we hit the ground running and it’s like
                  nothing you’ve ever experienced before)
                </i>
              </li>
              <li>
                {" "}
                <strong>Grow, Win, Celebrate! </strong>{" "}
                <i>(Wedding! Okay maybe that’s too soon…)</i>
              </li>
            </ol>
          </Box>
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
